import { Star, ArrowUpRight } from "lucide-react";
import { GOOGLE_REVIEWS } from "@/data/site";

function GoogleG({ className = "w-5 h-5" }) {
  return (
    <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
      <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9.1 3.6l6.8-6.8C35.8 2.4 30.3 0 24 0 14.6 0 6.5 5.4 2.6 13.2l7.9 6.1C12.4 13.6 17.7 9.5 24 9.5z" />
      <path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.1-.4-4.5H24v9h12.7c-.6 3-2.3 5.5-4.8 7.2l7.5 5.8c4.4-4.1 7.1-10.1 7.1-17.5z" />
      <path fill="#FBBC05" d="M10.5 28.7A14.6 14.6 0 0 1 9.5 24c0-1.6.3-3.2.8-4.7l-7.9-6.1A24 24 0 0 0 0 24c0 3.9.9 7.5 2.6 10.8l7.9-6.1z" />
      <path fill="#34A853" d="M24 48c6.3 0 11.7-2.1 15.6-5.7l-7.5-5.8c-2.1 1.4-4.8 2.3-8.1 2.3-6.3 0-11.6-4.1-13.5-9.8l-7.9 6.1C6.5 42.6 14.6 48 24 48z" />
    </svg>
  );
}

/** Compact "Rated X on Google" badge linking to the reviews page. */
export default function GoogleBadge({ compact = false }) {
  const { rating, count, url } = GOOGLE_REVIEWS;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="google-reviews-badge"
      className={`group inline-flex items-center gap-3 border border-white/10 bg-white/[0.03] hover:border-[#D4AF37]/60 hover:bg-[#D4AF37]/5 transition-colors duration-300 ${
        compact ? "px-3 py-2" : "px-4 py-3"
      }`}
    >
      <span className="w-9 h-9 bg-white flex items-center justify-center shrink-0">
        <GoogleG className="w-5 h-5" />
      </span>
      <span className="leading-tight">
        <span className="flex items-center gap-1.5">
          <span className="font-display text-white text-lg leading-none">{rating}</span>
          <span className="flex">
            {Array.from({ length: 5 }).map((_, i) => (
              <Star key={i} className="w-3 h-3 fill-[#D4AF37] text-[#D4AF37]" />
            ))}
          </span>
        </span>
        <span className="block text-[10px] uppercase tracking-[0.2em] text-white/50 mt-1 group-hover:text-white/80 transition-colors">
          {count ? `${count} Google reviews` : "Rated on Google"}
          <ArrowUpRight className="inline w-3 h-3 ml-1 -mt-0.5" />
        </span>
      </span>
    </a>
  );
}
